module.exports = __webpack_public_path__ + "img/lev-logo.b403cad6.svg";